// @core/api/endpoints/context/track_behavior.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TrackBehaviorRequest,
  TrackBehaviorResponse,
} from '../../../types/context';

const BASE_PATH = '/context';

/**
 * Track user behavior for context scoring
 * Records user interaction events (section expand, collapse, click) for behavior-based scoring. Events are batched by the frontend.
 */
export async function TrackBehavior(
  data: TrackBehaviorRequest,
  options?: RequestOptions
): Promise<TrackBehaviorResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/context/behavior`;
  const requestOptions = options;
  return client.post<TrackBehaviorResponse>(requestPath, data, requestOptions);
}
